angular.module('pulianiBookStoreApp')
.directive('loading',   ['$http' , '$timeout',function ($http,$timeout)
    {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs)
            {
                scope.isLoading = function () {
                    return $http.pendingRequests.length > 0;
                };

                scope.$watch(scope.isLoading, function (v)
                {
                    if(v){
                        elm.show();
                    }else{
                        elm.hide();
                    }

                    $timeout(function () {
                        elm.hide();
                    },3000)
                });
            }
        };

    }]);